import React, { useEffect, useState } from "react";
import { notificarError, notificarMsg } from "../Almacenes/AlmacenNotify";


export function EmpresaTransportistaAddForm (props) {
    const [payload, setPayload] = useState({
        NroDocumento: "",
        RazonSocial: "",
    });

    const [loading, setLoading] = useState(false);

    const handleBuscarPorRuc = async (e) =>{
        e.preventDefault();
        setLoading(true);

        if(!payload.NroDocumento || payload.NroDocumento.length < 8){
            notificarError("Ingrese un numero de documento valido");
            setLoading(false);
            return;
        }
        try {
            const response = await fetch(
                `${process.env.REACT_APP_API_CONSULTA_RUC2}/${payload.NroDocumento}`, 
                {
                    method: "GET",
                    headers: {
                        Accept: "application/json",
                        Authorization: `Bearer ${process.env.REACT_APP_TOKEN_API_RUC2}`
                    }
                }
            );

            const data = await response.json();

            if(data && data.name) {
                setPayload({
                    ...payload,
                    RazonSocial: data.name
                });
                notificarMsg("Empresa Encontrado");
            } else{
                notificarError("Empresa no Encontrado");
            }
        }
        catch (error){
            console.error("Error en consulta a Sunat:", error);
            notificarError("Error al consultar Empresa");
        } finally{
            setLoading(false);
        }

    }



    const register = async () => {
        if(!payload.NroDocumento || !payload.RazonSocial){
            notificarError("Complete los campos requeridos");
            return;
        }

        try {
            const req = await fetch('/api/guiaRemision/empresas-transportistas/', {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                method: "POST",
                body: JSON.stringify(payload),
            });

            if (!req.ok) {
                throw new Error("Error al registrar empresa transportista");
            }

            const res = await req.json();

            props.onSaveEmpresaTransportista({
                IdEmpresaTransportista: res.IdEmpresaTransportista,
                NroDocumento: payload.NroDocumento,
                RazonSocial: payload.RazonSocial,
            });
        } catch (e) {
            notificarError("No se pudo registrar la empresa transportista")
            console.error("Error al registrar empresa transportista: " ,e);
        }
    }

  return (
        <div className="pt-3 container">
            <div className="row">
                <div className="col-12">
                    <form onSubmit={handleBuscarPorRuc}>
                        <div className="form-group">
                            <label><strong>Nro. Documento (RUC)</strong></label>
                            <div className="input-group">
                                <input 
                                    type="text" 
                                    className="form-control" 
                                    value={payload.NroDocumento} 
                                    onChange={e => {
                                        setPayload({
                                            ...payload,
                                            NroDocumento: e.target.value,
                                        })
                                    }}
                                    placeholder="Ingrese RUC"
                                />
                                <div className="input-group-append">
                                    <button 
                                        className="btn btn-outline-secondary" 
                                        type="submit"
                                        disabled={loading}
                                    >
                                        {loading ? (
                                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        ) : (
                                            "Buscar"
                                        )}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>

                    <div className="form-group">
                        <label><strong>Razón Social</strong></label>
                        <input 
                            type="text" 
                            className="form-control" 
                            value={payload.RazonSocial} 
                            onChange={e => {
                                setPayload({
                                    ...payload,
                                    RazonSocial: e.target.value,
                                })
                            }}
                        />
                    </div>
                </div>
                
                <div className="col-12 d-flex justify-content-center mt-3">
                    <div className="seccion-btn-verde-mfp pb-3">
                        <button 
                            onClick={register} 
                            className="btn-verde-mfp btn btn-outline-primary px-3"
                            disabled={loading}
                        >
                            Registrar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

